"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _UIAbstractPageTemplate = _interopRequireDefault(require("./UIAbstractPageTemplate"));

function UIListingPage(props) {
  return _react.default.createElement(_UIAbstractPageTemplate.default, (0, _extends2.default)({}, props, {
    horizontalDivider: true
  }));
}

UIListingPage.propTypes = (0, _omit.default)(_UIAbstractPageTemplate.default.propTypes, 'horizontalDivider');
UIListingPage.defaultProps = (0, _omit.default)(_UIAbstractPageTemplate.default.defaultProps, 'horizontalDivider');
UIListingPage.displayName = 'UIListingPage';
var _default = UIListingPage;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/page/UIListingPage.js
// module id = 255
// module chunks = 209 210 211 212